import React, {useState} from "react";
import styled from "styled-components";
import {TitleSection} from "../../views/course_details/components/Styles";
import Color from "../../assets/Colors";
import {TypeTitle} from "../../styles/Products";
import {ButtonSubmit} from "../footer/styles";
import {SelectedContainer} from "../../styles/GlobalStyles";
import Text from "../../styles/Text";
import {SendFormService} from "../../services/GeneralServices";
import AppLoader from "../loaders/Loader";

const ContactActionForm = React.forwardRef((props, ref) => {
   const [isSaving, setSaving] = useState(false);
   const [errorList, setErrorList] = useState([]);

   const sendMail = (e) => {
      e.preventDefault();
      e.persist();

      let formd = e.target;

      setSaving(true);
      setErrorList([]);

      let toSend = {
         email: formd.email.value,
         name: formd.name.value,
         company: formd.enterprise.value,
         interest: formd.interest.value,
         phone: formd.phone.value,
         message: formd.message.value,
         type: props.type,
      };

      const resetFo = () => e.target.reset();

      SendFormService(toSend)
         .then((res) => res.json())
         .then((resp) => {
            const {status} = resp;
            if (status === "error") throw new Error();
         })
         .then(() => {
            resetFo();
         })
         .then(() => {
            setSaving(false);
         })
         .catch((e) => {
            setSaving(false);
            setErrorList([...errorList, {text: "Ocurrió un error, intenta más tarde"}]);
         });
   };
   return (
      <>
         <FormSection ref={ref} width={props.width}>
            <TitleSection style={{marginBottom: props.showDesc ? "0" : "3em"}}>
               <img
                  src={props.icon || require("../../assets/icons/contact_icon.png")}
                  alt="offer"
                  className={`titleIcon  ${props.iconClass}}`}
               />
               <TypeTitle as="span" className="principal" color={Color.primary}>
                  {props.title || "Ponte en contacto"}
               </TypeTitle>
            </TitleSection>

            {props.showDesc && (
               <Text style={{marginBottom: "3em", marginTop: "1em"}} color={Color.textColor}>
                  Si estás interesado en formar parte de nuestro programa ponte en contacto con nosotros.
               </Text>
            )}

            <FormStyled onSubmit={sendMail}>
               <section className="section">
                  <input placeholder="Nombre" type="text" name="name" required />
                  <input placeholder="Empresa" type="text" name="enterprise" required />
                  <input placeholder="Interés" type="text" name="interest" required />
                  <input placeholder="Mail" type="email" name="email" required />
                  <input placeholder="Teléfono" type="phone" name="phone" required />
               </section>
               <section className="section">
                  <input className="label" value="Mensaje" readOnly={true} required />
                  <textarea name="message" />

                  {React.Children.toArray(errorList.map((item) => <Text color="crimson">{item.text}</Text>))}

                  <SendButton centerBtn={props.centerBtn}>ENVIAR</SendButton>
               </section>
            </FormStyled>
         </FormSection>
         <AppLoader isVisible={isSaving} />
      </>
   );
});

export default ContactActionForm;

ContactActionForm.defaultProps = {
   centerBtn: false,
};

const FormSection = styled.div`
   width: ${(props) => props.width || "90%"};
   margin: 0 auto;

   & ${TitleSection} {
      margin-bottom: 4em;
      margin-top: 0;
      display: flex;
      align-items: center;

      & img {
         margin-right: 0.5em;
         width: 30px;
      }

      @media screen and (max-width: 1600px) {
         & img {
            width: 25x;
         }
      }
      @media screen and (max-width: 500px) {
         & img {
            width: 16px;
         }
      }
   }

   @media screen and (max-width: 500px) {
      flex-direction: column;
      width: 100%;
   }
`;

const FormStyled = styled.form`
   width: 100%;
   margin: 0 auto;
   display: flex;
   justify-content: space-between;

   & .section {
      width: 46%;
      padding: 1em 0;
   }

   & input,
   & textarea {
      border: none;
      outline: none;
   }

   & input {
      width: 100%;
      padding: 0.5em;
      border-bottom: 1px solid rgba(193, 193, 193, 0.8) !important;
      color: ${Color.textColor};
      font-weight: 200;
      font-size: 1em;
      margin-bottom: 2.2em;

      &.label {
         border-bottom: none;
         margin-bottom: 0em;
      }

      ::placeholder {
         color: ${Color.textColor};
         font-weight: 200;
         font-size: 1em;
         padding: 0.5em;
      }
   }
   & textarea {
      width: 100%;
      padding: 0.5em;
      border: 1px solid rgba(193, 193, 193, 0.8);
      font-weight: 200;
      height: 60%;
   }

   & ${SelectedContainer} {
      margin-bottom: 3em;
      margin-top: 0;
      display: block;

      & select {
         height: auto;
         border-bottom: 1px solid rgba(193, 193, 193, 0.8);
      }
   }

   @media screen and (max-width: 500px) {
      flex-direction: column;

      & .section {
         width: 100%;
         padding: 0;
      }

      & input,
      & ${SelectedContainer} {
         padding: 0.1em 0;
         border: none;
         font-size: 1.2em;
         padding-bottom: 0.5em;
      }

      & textarea {
         height: 150px;
      }
   }
`;

const SendButton = styled(ButtonSubmit)`
   width: 41%;
   display: block;
   margin: ${(props) => (props.centerBtn ? "0 auto" : "0")};
   padding: 20px 0;
   font-size: 15px;
   border: 1px solid ${Color.primary};
   margin-top: 1em;

   @media screen and (max-width: 1600px) {
      padding: 16px 0;
   }

   @media screen and (max-width: 500px) {
      width: 100%;
      color: white;
      background: ${Color.primary};
   }
`;
